import * as gqlmin from 'gqlmin';

const MAX_ATTEMPTS = 5;

const isRetryable = (status: number) => status === 429 || status >= 500;

// Contentful sends the seconds until the rate limit resets; otherwise back off exponentially
const retryDelayMs = (response: Response, attempt: number) => {
  const resetSeconds = Number(response.headers.get('X-Contentful-RateLimit-Reset'));
  const backoff = resetSeconds > 0 ? resetSeconds * 1000 : 500 * 2 ** attempt;
  return backoff + Math.random() * 250;
};

const sleep = (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export async function fetchGraphQL(query: string, isPreview: boolean) {
  const request = () =>
    fetch(
      `https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/environments/${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: isPreview
            ? `Bearer ${process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_TOKEN}`
            : `Bearer ${process.env.PUBLIC_CONTENTFUL_DELIVERY_TOKEN}`,
        },
        body: JSON.stringify({ query: gqlmin.default(query) }),
      },
    );

  try {
    let response = await request();
    for (let attempt = 1; attempt < MAX_ATTEMPTS && isRetryable(response.status); attempt += 1) {
      // eslint-disable-next-line no-await-in-loop
      await sleep(retryDelayMs(response, attempt));
      // eslint-disable-next-line no-await-in-loop
      response = await request();
    }
    return await response.json();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    throw err;
  }
}
